import link from "@root/tabulator/Actions/link";
import resetPassword from "@root/tabulator/Actions/reset-password";

export default function actionMapper(name) {
  return {
    link,
    'reset-password': resetPassword,

  }[name] || null
}